import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import { useGlobalProperty } from "../context/GlobalPropertyContext";
import { useAuth } from "../context/AuthContext";
import 'swiper/css';
import 'swiper/css/navigation';
import { API } from "../api";
import "../styles/style_footer.css";
import {parseSocialMedia, SafeIonIcon, formatPhoneFR} from "../utils/validators";

// Import des images pour les exemples
import bouquetL from "../assets/pictures/carrousel/source/img_atelierFloral_ByHEGCreation_67c1011f0c96e4.18886685.jpg";
import bouquetXL from "../assets/pictures/carrousel/source/img_atelierFloral_ByHEGCreation_67c10157c54226.64095504.jpg";
import bouquetM from "../assets/pictures/carrousel/source/img_atelierFloral_ByHEGCreation_67c1012de54a16.51812603.jpg";
import fondCommandes from "../assets/fondComandes.jpg";

function Footer() {
  const navigate = useNavigate();
  const location = useLocation();
  const { globalProperties, loading: globalLoading } = useGlobalProperty();
  const { user } = useAuth();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const blacklistPaths = new Set(["/auth", "/admin"]);

  // Données artificielles pour les exemples de créations
  const mockProducts = [
    {
      id: 1,
      nom: "Bouquet Romantique",
      prix: 45,
      imagepath: bouquetL,
      isvisible: true
    },
    {
      id: 2,
      nom: "Composition Élégante",
      prix: 65,
      imagepath: bouquetXL,
      isvisible: true
    },
    {
      id: 3,
      nom: "Bouquet Champêtre",
      prix: 35,
      imagepath: bouquetM,
      isvisible: true
    },
    {
      id: 4,
      nom: "Création Sur Mesure",
      prix: 85,
      imagepath: bouquetL,
      isvisible: true
    },
    {
      id: 5,
      nom: "Bouquet de Saison",
      prix: 55,
      imagepath: bouquetXL,
      isvisible: true
    },
    {
      id: 6,
      nom: "Arrangement Floral",
      prix: 75,
      imagepath: bouquetM,
      isvisible: true
    }
  ];

  // Récupérer les produits pour le mini carrousel
  useEffect(() => {
    const fetchProducts = async () => {
      try {
        // Essayer de récupérer les produits de l'API
        const response = await API.get("carrousel");
        if (response?.data && response.data.length > 0) {
          // Prendre seulement les 6 premiers produits visibles
          const visibleProducts = response.data
            .filter(product => {
              const now = new Date();
              const dateVisible = new Date(product.datepimg);
              return product.isvisible && dateVisible <= now;
            })
            .slice(0, 6);
          
          if (visibleProducts.length > 0) {
            setProducts(visibleProducts);
          } else {
            setProducts(mockProducts);
          }
        } else {
          setProducts(mockProducts);
        }
      } catch (error) {
        console.error("Erreur lors de la récupération des produits:", error);
        setProducts(mockProducts);
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, []);

  const handleLogout = async () => {
    const { success, error } = await API.post("auth/logout");
    if (success) setUser(null);
  };

  console.log("Footer - globalProperties:", globalProperties);

  if (blacklistPaths.has(location.pathname)) return null;
  if (globalProperties?.configuration?.is_home_restricted) return null;

  const socialLinks = parseSocialMedia(globalProperties?.social_media).filter(item => item.social_media_active).sort((a, b) => a.social_media_order - b.social_media_order);

  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container">
        
        {globalProperties?.configuration?.is_shop_active && (
          <section className="footer-section footer-carousel-section">
            <h3 className="footer-section-title"><span className="flower-icon">💐</span>Nos Créations<span className="flower-icon">💐</span></h3>
            
            {!loading && products.length > 0 ? (
              <div className="footer-carousel-wrapper">
                <Swiper
                  modules={[Navigation]}
                  spaceBetween={10}
                  slidesPerView={1}
                  breakpoints={{
                    640: { slidesPerView: 2 },
                    768: { slidesPerView: 3 },
                  }}
                  navigation={{
                    nextEl: '.footer-swiper-button-next',
                    prevEl: '.footer-swiper-button-prev',
                  }}
                  className="footer-carousel"
                >
                  {products.map((product) => (
                    <SwiperSlide key={product.id}>
                      <div className="footer-product-card" onClick={() => navigate("/", { state: { productId: product.id } })}>
                        {product.imagepath && (
                          <img src={product.imagepath} alt={product.nom} className="footer-product-image"/>
                        )}
                        <p className="footer-product-name">{product.nom}</p>
                        {product.prix && (
                          <p className="footer-product-price">{product.prix}€</p>
                        )}
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
                <button className="footer-swiper-button-prev"><ion-icon name="chevron-back-outline"></ion-icon></button>
                <button className="footer-swiper-button-next"><ion-icon name="chevron-forward-outline"></ion-icon></button>
              </div>
            ) : (<p className="footer-no-products">Découvrez nos créations florales</p>)}
          </section>
        )}

        <section className="footer-section footer-navigation-section">
          <h3 className="footer-section-title">Navigation</h3>
          <ul className="footer-nav-list">
            {location.pathname !== '/' ? (
              <li><button className="footer-link" onClick={() => navigate("/")}>Accueil</button></li>
            ) : (
              <>
                <li><button className="footer-link" onClick={() => document.getElementById("carrousel")?.scrollIntoView({ behavior: "smooth" })}>Créations</button></li>
                <li><button className="footer-link" onClick={() => document.getElementById("evenement")?.scrollIntoView({ behavior: "smooth" })} >Événements</button></li>
              </>
            )}
            {!location.pathname !== '/boutique' && globalProperties?.configuration?.is_shop_active && (<li><button className="footer-link" onClick={() => navigate("/boutique")}>Boutique</button></li>)}
            {!location.pathname !== '/auth' && !user && <li><button className="footer-link" onClick={() => navigate("/auth")}>Connexion</button></li>}
            {!location.pathname !== '/profil' && user && <li><button className="footer-link" onClick={() => navigate("/profil")}>Profil d'Utilisateur</button></li>}
            { user && <li><button className="footer-link" onClick={(e) => { e.stopPropagation(); handleLogout();}}>Déconnexion</button></li>}
          </ul>
        </section>

        <section className="footer-section footer-legal-section">
          <h3 className="footer-section-title">Informations Légales</h3>
          <ul className="footer-legal-list">
            <li><button className="footer-link footer-legal-link" onClick={() => navigate("/mentions-legales")}>Mentions Légales</button></li>
            <li><button className="footer-link footer-legal-link" onClick={() => navigate("/politique-confidentialite")}>Politique de Confidentialité</button></li>
            <li><button className="footer-link footer-legal-link" onClick={() => navigate("/conditions-utilisation")}>Conditions d'Utilisation</button></li>
            <li><button className="footer-link footer-legal-link" onClick={() => navigate("/cookies")}>Gestion des Cookies</button></li>
          </ul>
        </section>

        {/* Section Contact & Réseaux Sociaux */}
        <section className="footer-section footer-contact-section">
          <h3 className="footer-section-title">Nous Contacter</h3>
          <div className="footer-contact-info">
            {globalProperties?.address && (
            <p className="footer-contact-item" onClick={() => window.open(globalProperties?.address?.googleGPSLink, '_blank')}>
              <ion-icon name="location-outline"></ion-icon>
              <span>
                {globalProperties?.address?.street + ", " + globalProperties?.address?.postal_code + ","}
                <br/>{globalProperties?.address?.city}
                <br/>{globalProperties?.address?.country}
              </span>
            </p>
            )}

            {globalProperties?.contacte?.phone !== '' && (
              <p className="footer-contact-item" onClick={() => window.open(`tel:${globalProperties?.contacte?.phone}`, '_blank')}>
                <ion-icon name="call-outline"></ion-icon>
                <span>{formatPhoneFR(globalProperties?.contacte?.phone)}</span>
              </p>
            )}

            {globalProperties?.contacte?.email !== '' && (
              <p className="footer-contact-item" onClick={() => window.open(`mailto:${globalProperties?.contacte?.email}`, '_blank')}>
                <ion-icon name="mail-outline"></ion-icon>
                <span>{globalProperties?.contacte?.email} </span>
              </p>
            )}
          </div>

          {socialLinks.length > 0 && (
            <div className="footer-social-links">
              {socialLinks.map((media, index) => (
                <a
                  key={index}
                  href={media.social_media_url}
                  className="footer-social-link"
                  aria-label={media.social_media_label || media.social_media_name}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <SafeIonIcon name={media.social_media_icon || "link-outline"} />
                </a>
              ))}
            </div>
          )}
        </section>

      </div>

      <div className="footer-divider"></div>
      <div className="footer-bottom">
        <p className="footer-copyright">© {currentYear} L'Atelier Floral - Tous droits réservés.</p>
        <p className="footer-tagline">🌺 Créations Florales Artisanales 🌺</p>
      </div>
    </footer>
  );
}

export default Footer;
